// extracted by mini-css-extract-plugin
module.exports = {"headerColumn":"style_headerColumn__fWDN9","rowColumn":"style_rowColumn__1K7Ds","feedName":"style_feedName__2s8cj"};